export default "__VITE_ASSET__CAHPTbUg__"